import React, { useEffect, useRef } from 'react';

export default function WebpagesFolderContextMenu({ x, y, node, clipboard, allowPaste, onClose, onAction }) {
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [onClose]);

  if (!node) return null;

  const isAll = !!node.isAll;

  const items = [];

  if (!isAll) {
    items.push({ label: 'New Folder', icon: 'ti-plus', action: 'new-folder' });
    items.push({ label: 'Rename', icon: 'ti-pencil-alt', action: 'rename' });
    items.push({ label: 'Copy', icon: 'fa fa-copy', action: 'copy' });
    items.push({ label: 'Cut', icon: 'fa fa-cut', action: 'cut' });
  }

  if (!isAll && clipboard && allowPaste) {
    items.push({ label: 'Paste', icon: 'fa fa-paste', action: 'paste' });
  }

  if (!items.length) return null;

  return (
    <ul
      className="dropdown-menu"
      style={{
        display: 'block',
        position: 'fixed',
        top: y,
        left: x,
        minWidth: 180,
        zIndex: 2000,
      }}
      ref={ref}
    >
      {items.map((item, idx) => (
        <li key={idx}>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              onAction(item.action, node);
              onClose();
            }}
            style={{ display: 'flex', alignItems: 'center', gap: 8 }}
          >
            <i className={item.icon} style={{ width: 16 }} aria-hidden="true" />
            <span>{item.label}</span>
          </a>
        </li>
      ))}
    </ul>
  );
}
